import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Wifi2BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_2_bar"}/>
}
